import VendorConfigContainer from "./VendorConfigContainer";
import VendorConfigStore from "./VendorConfigStore";
export default VendorConfigStore(VendorConfigContainer); 